import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import TktInstancesList from './TktInstancesList/TktInstancesList';
import TktInstanceShow from './TktInstanceShow/TktInstanceShow';
import TktInstanceEdit from './TktInstanceEdit/TktInstanceEdit';
import TktInstanceCreate from './TktInstanceCreate/TktInstanceCreate';
import TktInstanceDelete from './TktInstanceDelete/TktInstanceDelete';

const TktInstances = ({ match }) => {
    return (
        <div className="TktInstances">
            <ContainerWrapper container="tktInstances">
                <Route exact path={match.path} component={TktInstancesList} />
                <Route exact path={`${match.url}/new`} component={TktInstanceCreate} />
                <Route exact path={`${match.url}/show/:tktInstanceId`} component={TktInstanceShow} />
                <Route exact path={`${match.url}/delete/:tktInstanceId`} component={TktInstanceDelete} />
                <Route exact path={`${match.url}/edit/:tktInstanceId`} component={TktInstanceEdit} />
            </ContainerWrapper>
        </div>
    );
}

export default TktInstances;
